module["exports"] = [
  "ИП",
  "ООО",
  "ЗАО",
  "ОАО",
  "НКО",
  "ТСЖ",
  "ОП"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/ru/company/prefix.js
// module id = 1190
// module chunks = 0